<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="epigraph"></a></div>
<div class="block">
<div class="block">
<div class="block">
<p class="noindent" style="margin-top: 20%"><i>All the rivers run into the sea; yet the sea is not full; unto the place from whence the rivers come, thither they return again. All things are
        full of labour; man cannot utter it: the eye is not satisfied with seeing, nor the ear filled with hearing. The thing that hath been, it is that which shall be; and that which is done is that
        which shall be done: and there is no new thing under the sun.</i></p>
<div class="top">
<p class="right">Ecclesiastes 1:7–9</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_epigraph.vue?842d032c